'use client';

import classnames from 'classnames';

import { Badge } from '../../badge';
import type { BaseComponentProps } from '../../base-component.types';

import styles from './TagList.module.scss';

type TagListProps = BaseComponentProps & {
  tags?: string[];
};

/** What a question or an assessment is tagged with. Nothing to show renders nothing. */
function TagList({ style, className, tags, testId }: TagListProps) {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <div
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      {tags.map((tag) => (
        <Badge key={tag} bg="featured">
          {tag}
        </Badge>
      ))}
    </div>
  );
}

export { TagList };
